<template>
  <div id="demo-basic-card">

    <div id="module-data">
        <div id="addPackageLoadingDiv" class="vs-con-loading__container">
            <vx-card :title="packageName" class="mb-base">
                <template   slot="actions">
                    <vx-tooltip text="Back to all packages" position="left">
                        <feather-icon @click="redirectToAllPackages()" icon="ChevronsLeftIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
                    </vx-tooltip>
                </template>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full mb-2">
                        Package name
                        <vs-input v-validate="'required'" name="name" ref="name" class="w-full" label="" v-model="package_data.name" />
                        <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-2">
                        Price Type
                        <v-select v-validate="'required'" name="type" ref="type" v-model="priceType" :options="['Free','Cost']" />
                        <span class="text-danger text-sm" v-show="errors.has('type')">{{ errors.first('type') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-2" v-if="priceType == 'Cost'">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <vs-input v-validate="'min:1|max_value:1000000'" name="cost" ref="cost" class="w-full" label="Cost" v-model="package_data.cost" />
                        <span class="text-danger text-sm" v-show="errors.has('cost')">{{ errors.first('cost') }}</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <vs-input v-validate="'max_value:1000000'" name="special_price" ref="special_price" class="w-full" label="Special price" v-model="package_data.special_price" />
                        <span class="text-danger text-sm" v-show="errors.has('special_price')">{{ errors.first('special_price') }}</span>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col  w-full mb-4">
                        Modules
                        <treeselect v-validate="'required'" name="module_id" ref="module_id" v-model="modules_values" :multiple="true" :options="modules_options" />
                        <span class="text-danger text-sm" v-show="errors.has('module_id')">{{ errors.first('module_id') }}</span>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col  w-full mb-2">
                        Description
                        <vs-textarea  v-model="package_data.description" />
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col w-full"  align="right">
                      <vs-button @click="validateCreatePackage()" class="mr-3 mb-2">Save Changes</vs-button>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import modulePackageManagement from '@/store/package-management/modulePackageManagement.js'
import moduleModuleManagement from '@/store/module-management/moduleModuleManagement.js'
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import vSelect from 'vue-select'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default{
    data() {
        return {
            package_data: {
                name : null,
                cost : null,
                special_price : null,
                description : null,
                price_type : 'free',
            },
            package_not_found: false,
            swiperOption: {
                pagination: {
                    el: '.swiper-pagination'
                }
            },
            modules_values : [],
            modules_options : [],
            otherModuleType_ : null,
            packageName : null,
        }
    },
    components: {
        VuePerfectScrollbar,
        swiper,
        swiperSlide,
        vSelect,
        Treeselect,
    },
    computed: {
        priceType: {
            set: function(val) {
                this.package_data.price_type = val.toLowerCase();
            },
            get: function() {
                let type = this.package_data.price_type
                return type[0].toUpperCase() + type.slice(1);
            }
        },
    },
    methods: {
        redirectToAllPackages() {
            this.$router.push("/packages").catch(() => {})
        },
        validateCreatePackage() {
            this.$validator.validateAll().then(result => {
                if (result) this.createPackage()
                else{

                }
            })
        },
        createPackage() {
            var self = this

            this.$vs.loading({
                container: '#addPackageLoadingDiv',
                scale: 0.6
            })

            let packageData = this.package_data
            packageData.module_id = this.modules_values

            this.$store.dispatch("packageManagement/createPackage", packageData)
            .then(res => { 
                this.$vs.loading.close('#addPackageLoadingDiv > .con-vs-loading')

                this.$vs.notify({
                  time:4000,
                  title:'Success',
                  text: (res.data.status) ? res.data.status : 'Sussfully Updated.',
                  color:'success',
                  iconPack: 'feather',
                  icon:'icon-alert-circle'
                });

                if(res.status == 201){
                    this.$router.push("/packages/edit/" + res.data.package.id).catch(() => {})
                }
            })
            .catch(err => {
                this.$vs.loading.close('#addPackageLoadingDiv > .con-vs-loading')

                if(err.status && err.status == 422){
                    Object.keys(err.data).forEach(function(key) {
                        self.errors.add({
                            field: key,
                            msg: err.data[key][0],
                        });
                    });
                }
            })
        },
    },
    created() {
        if(!modulePackageManagement.isRegistered) {
            this.$store.registerModule('packageManagement', modulePackageManagement)
            modulePackageManagement.isRegistered = true
        }

        if(!moduleModuleManagement.isRegistered) {
            this.$store.registerModule('moduleManagement', moduleModuleManagement)
            moduleModuleManagement.isRegistered = true
        }

        this.$store.dispatch("moduleManagement/getAllModules")
            .then(res => { 
                let modules_options = [];
                res.data.forEach(function(entry) {
                    modules_options.push({
                        id : entry.id,
                        label : entry.name,
                    }); 
                });

                this.modules_options = modules_options
            })
            .catch(err => { 

            })
    },

}
</script>

